import React, { FC, memo, forwardRef } from 'react'
import * as S from './styles'
import { LinkProps } from './types'

export const Link: FC<LinkProps> = memo(
  forwardRef<HTMLAnchorElement, LinkProps>(
    ({ kind = 'link', size = 'md', onClick = () => {}, children, className, isBlank = false, ...rest }, ref) => {
      const restProps = { ...rest }

      if (isBlank) {
        restProps.target = '_blank'
        restProps.rel = 'noopener'
      }

      return (
        <S.Link ref={ref} kind={kind} size={size} onClick={onClick} className={className} {...restProps}>
          {children}
        </S.Link>
      )
    }
  )
)

Link.displayName = 'Link'
